// src/utils/localization.ts
import { createSignal } from "solid-js";
var locals = {};
var localStorageKey = "locale";
var setI18n = (options) => {
  locals = options.locals;
  if (options.localStorageKey) {
    localStorageKey = options.localStorageKey;
  }
  setCurrentLanguage(getInitialLocale());
};
var getInitialLocale = () => {
  if (Object.keys(locals).length === 0) {
    throw new Error("Please provide locals first");
  }
  if (typeof window === "undefined") {
    return Object.keys(locals)[0];
  }
  let localeToUse = Object.keys(locals)[0];
  const storedLocale = localStorage.getItem(localStorageKey);
  if (storedLocale && storedLocale in locals) {
    localeToUse = storedLocale;
  }
  return localeToUse;
};
var [currentLanguage, setCurrentLanguage] = createSignal(Object.keys(locals)[0]);
var useLocalization = () => {
  const changeLanguage = (toLocale) => {
    const newLocale = toLocale || Object.keys(locals)[0];
    if (typeof window !== "undefined") {
      localStorage.setItem(localStorageKey, newLocale);
    }
    setCurrentLanguage(newLocale);
  };
  const t = (key, params) => {
    const _currentLanguage = currentLanguage();
    if (!key) return "";
    if (!_currentLanguage) return key;
    let translation = locals[_currentLanguage][key] || key;
    if (params) {
      Object.entries(params).forEach(([paramKey, paramValue]) => {
        const regex = new RegExp(`{${paramKey}}`, "g");
        translation = translation.replace(regex, paramValue.toString());
      });
    }
    if (!translation && import.meta.env.DEV) {
      return `[Translation: '${key}']`;
    }
    return translation;
  };
  return { t, changeLanguage, currentLanguage };
};

export {
  setI18n,
  useLocalization
};
